import type { ICPQCart } from 'api/cart/types';
import { requestHandlerFabric } from 'api/instance';
import { getApiPrefix } from 'common/constants';
import type { IAssemblyGroup, ISummaryData } from './types';

const prefix = () => `${getApiPrefix()}/assembly-groups`;

export const createGroup = async (sessionId: string): Promise<{ groupKey: string }> => {
  const result = (await requestHandlerFabric().post<{ groupKey: string }>(prefix(), { sessionId })).data;
  return result;
};

export const addItem = async (
  groupKey: string,
  cartData: ICPQCart,
  summaryData: ISummaryData,
  content: string,
  sessionId?: string,
  skipPreRender?: boolean,
): Promise<{ itemId: string; position: number }> => {
  const result = (await requestHandlerFabric().post<{ itemId: string; position: number }>(
    `${prefix()}/${groupKey}/items`,
    {
      cartData: { ...cartData, sessionId },
      summaryData,
      content,
      skipPreRender,
    },
  )).data;
  return result;
};

export const removeItem = async (groupKey: string, itemId: string): Promise<void> => {
  await requestHandlerFabric().delete(`${prefix()}/${groupKey}/items/${itemId}`);
};

export const getGroup = async (groupKey: string): Promise<IAssemblyGroup> => {
  const result = (await requestHandlerFabric().get<IAssemblyGroup>(`${prefix()}/${groupKey}`)).data;
  return result;
};

export const completeGroup = async (groupKey: string): Promise<{ url: string; status: string }> => {
  const result = (await requestHandlerFabric().post<{ url: string; status: string }>(
    `${prefix()}/${groupKey}/complete`,
  )).data;
  return result;
};

